import { InputType } from '@app/enums/shared/input-type';
import { Country } from '@app/enums/country';
import { Filters } from './filters';

export type AnalyticsFilters = Filters<{
  timeperiod1: AnalyticsFilter<InputType.DateRange, DateRangeValue>;
  timeperiod2: AnalyticsFilter<InputType.DateRange, DateRangeValue>;
  revenueFrom: AnalyticsFilter<InputType.Text, string>;
  revenueTo: AnalyticsFilter<InputType.Text, string>;
  entitySizes: AnalyticsFilter<InputType.Multiselect, string[]>;
  businessSectors: AnalyticsFilter<InputType.Multiselect, string[]>;
  countryCodes: AnalyticsFilter<InputType.Multiselect, Country[]>;
}>;

export type AnalyticsFilter<TType extends InputType, TValue> = {
  type: TType;
  value: TValue;
};

export type DateRangeValue = {
  dateStart: string;
  dateEnd: string;
};

export type AnalyticsTimePeriod = 'A' | 'B';

export const defaultAnalyticsSearchFilters: AnalyticsFilters = {
  timeperiod1: {
    type: InputType.DateRange,
    value: {
      dateStart: '',
      dateEnd: '',
    },
  },
  timeperiod2: {
    type: InputType.DateRange,
    value: {
      dateStart: '',
      dateEnd: '',
    },
  },
  revenueFrom: {
    type: InputType.Text,
    value: '',
  },
  revenueTo: {
    type: InputType.Text,
    value: '',
  },
  entitySizes: {
    type: InputType.Multiselect,
    value: [],
  },
  businessSectors: {
    type: InputType.Multiselect,
    value: [],
  },
  countryCodes: {
    type: InputType.Multiselect,
    value: [],
  },
};
